module.exports = __webpack_public_path__ + "static/disease_spanish-1b26ddf2c243f26e695bd69ae0dcb6c1.png";